import script from "./SidebarLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarLink.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarLink.vue?vue&type=style&index=0&id=e34dc308&lang=scss"

const __exports__ = script;

export default __exports__